export const HITL_FEATURE_FLAG = "hitl";

export function isHitlEnabled(featureFlags?: string[] | null): boolean {
  return (featureFlags ?? []).includes(HITL_FEATURE_FLAG);
}

export function getAwaitingInputRoute(
  reportId: string | null | undefined,
  hitlEnabled: boolean
): string {
  if (!reportId) {
    return "/";
  }

  const encodedReportId = encodeURIComponent(reportId);

  return hitlEnabled
    ? `/review-plan/${encodedReportId}`
    : `/preview-report-info/${encodedReportId}`;
}

export function getAwaitingInputActionLabel(hitlEnabled: boolean): string {
  return hitlEnabled ? "Review Clarifications" : "View Report";
}

export function getAwaitingInputDescription(hitlEnabled: boolean): string {
  return hitlEnabled
    ? "Review the clarification questions to continue generating your final draft."
    : "Open the report to continue the workflow.";
}

export function getAwaitingInputAriaLabel(hitlEnabled: boolean): string {
  return hitlEnabled ? "Review clarification questions" : "View report awaiting input";
}
